import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL } from '../config';

const AlertPage = () => {
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const fetchAlert = async () => {
      try {
        // Get the code from the URL query parameter
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get('code');

        if (!code) {
          setError('No alert code provided');
          setLoading(false);
          return;
        }

        // Fetch the alert data from the API
        const response = await axios.get(`${API_URL}/web/alert/${code}`);
        setAlert(response.data.alert);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to load alert');
        setLoading(false);
      }
    };

    fetchAlert();
  }, [location]);

  return (
    <div className="bg-gray-50 text-gray-800 px-4 py-12 min-h-screen">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Alert</h1>

        {loading ? (
          <div className="flex justify-center items-center h-32">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          </div>
        ) : error ? (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Error: </strong>
            <span className="block sm:inline">{error}</span>
          </div>
        ) : alert ? (
          <div>
            <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative" role="alert">
              <p className="text-lg">
                <pre>{alert?.message}</pre>
              </p>
            </div>
            <p className="text-sm mt-1">Created: {new Date(alert.created_at).toLocaleString()}</p>
          </div>
        ) : (
          <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative" role="alert">
            <span className="block sm:inline">No alert found</span>
          </div>
        )}
      </div>
    </div>
  )
};

export default AlertPage;